export function makePanelHeader(titleText: string, onClose: () => void): HTMLDivElement {
  const header = document.createElement("div");
  header.className = "panel-header";
  const title = document.createElement("div");
  title.className = "panel-title";
  title.textContent = titleText;
  const close = document.createElement("button");
  close.className = "panel-close";
  close.textContent = "×";
  close.addEventListener("click", onClose);
  header.appendChild(title);
  header.appendChild(close);
  return header;
}

/** Returns the title element so callers can keep a handle for refreshes. */
export function makePanelHeaderRef(
  onClose: () => void,
): { header: HTMLDivElement; title: HTMLDivElement } {
  const header = document.createElement("div");
  header.className = "panel-header";
  const title = document.createElement("div");
  title.className = "panel-title";
  const close = document.createElement("button");
  close.className = "panel-close";
  close.textContent = "×";
  close.addEventListener("click", onClose);
  header.appendChild(title);
  header.appendChild(close);
  return { header, title };
}
